import React from 'react';
import { createPortal } from 'react-dom';
import { observer } from 'mobx-react-lite';
import { ComplianceConfigAuditContent } from 'src/components/ComplianceAudit/ComplianceAudit';

interface SelfExclusionConfigAuditPropsType {
    onClose: () => void;
}

export const SelfExclusionConfigAudit = observer(
    ({ onClose }: SelfExclusionConfigAuditPropsType): JSX.Element =>
        createPortal(
            <div
                className='audits visible'
                data-test='self-exclusion-config-audit'
            >
                <div className='audits-content'>
                    <button
                        className='audits-minimize'
                        data-test='self-exclusion-config-audit-close'
                        onClick={onClose}
                        type='button'
                    />
                    <ComplianceConfigAuditContent feature='SelfExclusion' />
                </div>
            </div>,
            document.body
        )
);
